<div class="login-back">
  <div class="container">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">
              <img src="favicon.svg" width="32" style="margin-right: 5px" />{{
                appTitle
              }}
            </h5>
            @if (!isNewPassword) {
              <span class="card-sub-title" i18n="@@PasswordReset_SubTitle"
                >Reset your password</span
              >
            }
            @if (isNewPassword) {
              <span
                class="card-sub-title"
                i18n="@@PasswordReset_SubTitle_NewPassword"
                >Set new password</span
              >
            }
            <app-alert></app-alert>
            @if (validating) {
              <div class="validating-box">
                <app-spinner [IsLoading]="true"></app-spinner>
                <span i18n="@@PasswordReset_ValidatingToken">
                  Validating token, please wait...
                </span>
              </div>
            }
            @if (form && tokenIsValid && !changedSuccesfully) {
              <form
                class="form-signin"
                [formGroup]="form"
                (ngSubmit)="OnSubmit()"
              >
                <div class="row">
                  <div class="col">
                    <frm-text
                      formControlName="newPassword"
                      type="password"
                      i18n-label="@@PasswordReset_PasswordNew"
                      label="New Password"
                    ></frm-text>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <frm-text
                      formControlName="confirmPassword"
                      type="password"
                      i18n-label="@@PasswordReset_PasswordConfirm"
                      label="Confirm Password"
                    ></frm-text>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <ctrl-btn
                      [default]="true"
                      content="Reset Password"
                      i18n-content="@@PasswordReset_Submit"
                      [disabled]="loading || !form.valid"
                      [loading]="loading"
                      (click)="OnSubmit()"
                    ></ctrl-btn>
                  </div>
                </div>
              </form>
            }
            <div class="row">
              <div class="col">
                <a [routerLink]="'/login'" i18n="@@PasswordReset_BackToLogin"
                  >Back to login</a
                >
                <br />
                <a
                  [routerLink]="'/password-forgot'"
                  i18n="@@PasswordReset_ForgotPassword"
                  >Request another password reset token</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="position: absolute; left: 0; bottom: 0; right: 0">
    <app-footer [dark]="true" />
  </div>
</div>
